import React from "react";
import { CircularProgress as CircularProgressComponent, Box } from "@mui/material";

interface IProps {
  isLoading: boolean;
}
const CircularProgress = ({ isLoading }: IProps): React.ReactElement | null => {
  return isLoading ? (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 80,
      }}
    >
      <CircularProgressComponent />
    </Box>
  ) : null;
};

export default CircularProgress;
